import React, { useState } from 'react';
import useStores from '@stores/useStores';
import { DeleteOutlined } from '@ant-design/icons';
import Button from '@ui-library/button';
import useModalView from '@hooks/useModalView';
import Modal from '@ui-library/modal/custom';
import { LabelMedium } from '@ui-library/typography';

// name:String, resourceId:String, role:String!, source:{options:{}}, sink:{options:{},table:{}}
interface RemoveResourceProps {
  resourceId: string;
  onSuccess: () => void;
  sourceId?: string;
  disabled?: boolean;
}
const RemoveResource = ({ resourceId, sourceId, onSuccess, disabled }: RemoveResourceProps) => {
  const { messagesStore, sourceDataStore } = useStores();
  const [loading, setLoading] = useState(false);

  const handleDeleteResource = async () => {
    try {
      setLoading(true);
      if (sourceId) {
        await sourceDataStore.deleteCustomResource(sourceId, resourceId);
      }
      if (onSuccess) {
        onSuccess();
      }
      messagesStore.showSuccessMessage('Resource removed.');
    } catch (err) {
      messagesStore.showErrorMessage('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const [deleteModal, showDeleteModal] = useModalView(
    <Modal
      title={<div>Confirm</div>}
      content={<LabelMedium secondary>Are you sure you want to delete this resource?</LabelMedium>}
      onClose={() => showDeleteModal(false)}
      saveLabel="Yes, delete"
      saveLabelBtnType="deletePrimary"
      loading={loading}
      onSave={handleDeleteResource}
    />,
  );

  return (
    <>
      {deleteModal}
      <DeleteOutlined
        className="column_selection_button__delete"
        onClick={() => showDeleteModal(true)}
      />
      {!disabled ? (
        <Button
          textDelete
          className="column_selection_button__text_delete"
          style={{ display: 'none' }}
          onClick={() => showDeleteModal(true)}
          name="Delete"
        />
      ) : null}
    </>
  );
};

export default RemoveResource;
